<template>
  <el-row type="flex"   align="middle">
    <el-col :span="1"></el-col>
    <el-col :span="19">
      <div>
        <el-menu :default-active="activeIndex" :active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">发布应用</el-menu-item>
          <el-menu-item index="2">我的工作台</el-menu-item>
          <el-menu-item index="3">应用中心</el-menu-item>
          <el-menu-item index="4">文件管理</el-menu-item>
          <el-menu-item index="5">待定模块</el-menu-item>
        </el-menu>
      </div>
    </el-col>
    <el-col :span="4" >
      <div style="height: 100%;  line-height: 60px;text-align: right" >
         <el-link :underline="false" @click="quit">我要退出<i class="el-icon-s-promotion"></i></el-link>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'MainHead',
  data () {
    return {
      activeIndex: '1'
    }
  },
  beforeCreate () {
    this.bus.$on('busChangeHead', (key) => {
      this.handleSelect(key)
    })
  },
  methods: {
    handleSelect (key) {
      // console.log(key, keyPath)
      // 调用父组件的方法
      this.activeIndex = key
      this.$emit('func', key)
    },
    quit () {
      this.$cookie.delete('userName')
      this.$cookie.delete('userPassword')
      this.$cookie.delete('remember')
      this.$router.replace({path: '/login'})
    }
  }
}
</script>

<style scoped>
  .el-menu-item{
    padding-right: 30px;
    padding-left: 30px;
    font-size: medium;
  }
  .el-link{
    font-size: large;
  }
  .el-row{
    width: 100%;
    height: 100%;
  }
  .el-col{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainHead.vue